import { Procedure } from '../../../type/entity';
import MyService from '../../service';

export enum STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
}

const PartnerApi = {
  getAll: async () => {
    const result = await MyService.getRequestData('/partners');

    return result?.data ?? null;
  },

  getPartnerInList: async (listPartner: string) => {
    const result = await MyService.getRequestData(
      `/partners/get-in-list?partner=${listPartner}`
    );

    return undefined !== result ? result['data'] : null;
  },
  getPartnerByOptions: async (options: Record<string, any>) => {
    const result = await MyService.getRequestData(
      '/partners/get-by-options',
      options
    );

    return undefined !== result ? result['data'] : null;
  },

  getProcedures: async () => {
    try {
      const storageKey = 'procedures';

      let procs = null;
      if (null !== sessionStorage.getItem(storageKey)) {
        procs = JSON.parse(sessionStorage.getItem(storageKey) as string);
      }

      if (!procs) {
        const result = await MyService.getRequestData('/partners/produces');

        if (result) {
          procs = result['data'];
          sessionStorage.setItem(storageKey, JSON.stringify(result['data']));
        }
      }

      return procs as Procedure[];
    } catch (e) {
      console.log(e);
      return [];
    }
  },
  getAllWdays: async () => {
    const result = await MyService.getRequestData('/partners/wdays');

    return undefined !== result ? result['data'] : null;
  },
  getAllHolidays: async () => {
    const result = await MyService.getRequestData('/partners/holidays');

    return undefined !== result ? result['data'] : null;
  },
  getAllPaymenthods: async () => {
    const result = await MyService.getRequestData('/partners/paymenthods');

    return undefined !== result ? result['data'] : null;
  },
  createPartner: (partner: Record<string, any>) => {
    return MyService.postRequestData('/partners/', partner);
  },

  editPartner: async (partner: Record<string, any>) => {
    return MyService.postRequestData('/partners/edit', partner);
  },
  getAllStatus: async () => {
    const result = await MyService.getRequestData('/booking/all-status');

    return undefined !== result ? result['data'] : null;
  },
  deletePartner: (id: number) => {
    return MyService.putRequestData('/partners/delete', {
      part_id: id,
    });
  },

  getDetailPartner: async (part_id: Record<string, any>) => {
    const result = await MyService.getRequestData(
      '/partners/get-detail-partner',
      { part_id }
    );

    return undefined !== result ? result['data'] : null;
  },

  getById: async (part_id: number) => {
    const result = await MyService.getRequestData('/partners/get-by-id', {
      part_id,
    });

    return undefined !== result ? result['data'] : null;
  },
};

export default PartnerApi;
